import { Component } from '@angular/core';

@Component({
    selector: 'app-dropdown-additional-info-icon',
    standalone: true,
    imports: [],
    templateUrl: './dropdown-additional-info-icon.component.html',
    styleUrl: './dropdown-additional-info-icon.component.css'
})
export class DropdownAdditionalInfoIconComponent {

}
